// extracted by mini-css-extract-plugin
export default {"page":"VerifyPage_page__4jEqD","limit":"VerifyPage_limit__TeSMc","title":"VerifyPage_title__EldFz","loginLink":"VerifyPage_loginLink__ZLNf+"};